module.exports = __webpack_public_path__ + "img/swiper_3.5_5_3.6bb73697.webp";